import { useCallback } from 'react';
import { useNewRewardsApi } from 'Shared/services/Api';
import { GetRewardsEnrollmentResponse } from '@clearcover/core-app-types';

export type RewardsEnrollmentProviderType = {
  rewardsEnrollmentResponse: GetRewardsEnrollmentResponse | null;
  rewardsEnrollmentLoading: boolean;
  refreshRewardsEnrollment(): Promise<GetRewardsEnrollmentResponse>;
};

const TEN_SECONDS = 10000;

export const useRewardsEnrollment = (): RewardsEnrollmentProviderType => {
  const [
    {
      data: rewardsEnrollmentResponse,
      loading: rewardsEnrollmentLoading,
      refetch: fetchRewardsEnrollment,
    },
  ] = useNewRewardsApi<GetRewardsEnrollmentResponse>(
    {
      url: `/v1/enrollment`,
      timeout: TEN_SECONDS,
    },
    false,
    false
  );

  const refreshRewardsEnrollment = useCallback(async () => {
    return (await fetchRewardsEnrollment()).data;
  }, [fetchRewardsEnrollment]);

  return {
    rewardsEnrollmentResponse,
    rewardsEnrollmentLoading,
    refreshRewardsEnrollment,
  };
};
